import { render } from "./HeaderReport.vue?vue&type=template&id=f3163c28&scoped=true&ts=true"
import script from "./HeaderReport.vue?vue&type=script&lang=ts"
export * from "./HeaderReport.vue?vue&type=script&lang=ts"

import "./HeaderReport.vue?vue&type=style&index=0&id=f3163c28&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3163c28"]])

export default __exports__